import { render, staticRenderFns } from "./consent.vue?vue&type=template&id=54db47cf&scoped=true&"
import script from "./consent.vue?vue&type=script&lang=js&"
export * from "./consent.vue?vue&type=script&lang=js&"
import style0 from "./consent.vue?vue&type=style&index=0&id=54db47cf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54db47cf",
  null
  
)

export default component.exports